/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2020 - 2020
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import React, { useState, useEffect } from "react";
import styled from "styled-components";

import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import { fade } from "@material-ui/core/styles";
import { useTheme } from "@material-ui/core/styles";
import InputBase from "@material-ui/core/InputBase";
import SearchIcon from "@material-ui/icons/Search";
import ClearIcon from "@material-ui/icons/Clear";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";

const StyledSearchContainer = styled.div`
  position: relative;
  border-radius: ${(props) => props.theme.shape.borderRadius}px;
  background-color: ${(props) => fade(props.theme.palette.common.white, 0.9)};
  &:hover {
    background-color: ${(props) => props.theme.palette.common.white};
  }
  margin-left: ${(props) => props.theme.spacing(1)};
  width: auto;
`;

const StyledSearchIconContainer = styled.div`
  padding: ${(props) => props.theme.spacing(0, 2)};
  height: 100%;
  position: absolute;
  pointer-events: none;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledInputBase = styled(InputBase)`
  color: ${(props) => props.theme.palette.grey[800]};
  padding: ${(props) => props.theme.spacing(1, 1, 1, 0)};
  padding-left: ${(props) => `calc(1em + ${props.theme.spacing(4)}px)`};
  input {
    height: 8px !important;
    width: 160px;
    transition: ${(props) => props.theme.transitions.create("width")};
    &:focus {
      width: 180px;
    }
  }
`;

const MIN_CHAR_LIMIT = window.env.MIN_CHAR_LIMIT;
const MAX_CHAR_LIMIT_ROUTE_SEARCH = window.env.MAX_CHAR_LIMIT_ROUTE_SEARCH;

const BaseSearchField = ({
  isFetching,
  searchTerm,
  updateFilters,
  placeholder,
  defaultFilters,
}) => {
  const [searchTermLocal, setSearchTermLocal] = useState("");

  const dispatch = useDispatch();
  const history = useHistory();
  const theme = useTheme();

  useEffect(() => {
    if (searchTerm) {
      setSearchTermLocal(searchTerm);
    } else {
      setSearchTermLocal("");
    }
  }, [searchTerm]);

  const handleKeyPress = (event) => {
    if (
      event.key === "Enter" &&
      searchTermLocal &&
      searchTermLocal.length >= MIN_CHAR_LIMIT
    ) {
      dispatch(
        updateFilters({ filters: { searchTerm: searchTermLocal }, history })
      );
    }
  };

  const handleOnClick = () => {
    dispatch(updateFilters({ filters: { searchTerm: null }, history }));
    setSearchTermLocal("");
  };

  return (
    <StyledSearchContainer data-testid="search-element" theme={theme}>
      <StyledSearchIconContainer theme={theme}>
        <SearchIcon position="end" style={{ color: theme.palette.grey[700] }} />
      </StyledSearchIconContainer>
      <StyledInputBase
        placeholder={placeholder}
        theme={theme}
        onKeyPress={handleKeyPress}
        value={searchTermLocal}
        onChange={(event) => setSearchTermLocal(event.target.value)}
        inputProps={{
          maxLength: MAX_CHAR_LIMIT_ROUTE_SEARCH,
          "aria-label": "search",
        }}
        disabled={isFetching}
        endAdornment={
          <InputAdornment
            position="start"
            style={{
              opacity: searchTerm ? 1 : 0,
            }}
          >
            <IconButton
              onClick={handleOnClick}
              aria-label="clear-search-term"
              style={{ cursor: searchTerm ? "pointer" : "default" }}
            >
              <ClearIcon fontSize="small" />
            </IconButton>
          </InputAdornment>
        }
      />
    </StyledSearchContainer>
  );
};

export default BaseSearchField;
